import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
  position: relative;
`

export const Head = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`

export const Close = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`

export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  padding: 24px 12px;
  max-height: calc(44vw - 120px);

  @media (max-width: 1024px) {
    max-height: calc(60vw - 120px);
  }

  @media (max-width: 768px) {
    max-height: calc(80vw - 120px);
  }

  @media (max-width: 640px) {
    max-height: calc(80vh - 120px);
  }
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-evenly;
`
